import { AppEvents } from "@/lib/customEvents";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteChangeListener() {
  const location = useLocation();

  useLayoutEffect(() => {
    const routeEvent = new CustomEvent(AppEvents.RouteChange, {
      detail: { pathname: location.pathname },
    });
    window.dispatchEvent(routeEvent);
  }, [location]);

  return null;
}
